module.exports = __webpack_public_path__ + "img/shiba-head-level1.a4e136cd.png";